import Link from "next/link";
import React from "react";
import Amenities from "./Amenities";
import Location from "./Location";
import Rating from "./Rating";
import AdvancePayment from "./AdvancePayment";

const VillaInfo = ({ villa, listVilla }) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-start justify-between mb-2 sm:mb-3">
        <div className="flex flex-col gap-1">
          <Location location={villa.destination} />
          <Link
            href={villa.url}
            title={villa.title}
            prefetch={false}
            className="text-xl font-medium leading-normal text-themeBlack"
          >
            {villa?.name}
          </Link>
        </div>
        {!listVilla && <Rating rating={villa.rating} reviews={villa.reviews} />}
      </div>
      {listVilla && <AdvancePayment deposite={villa.depozito} />}
      <Amenities
        beds={villa.yatak_odasi}
        bathrooms={villa.banyo}
        capacity={villa.kisi}
      />
    </div>
  );
};

export default VillaInfo;
